import { createFileRoute } from '@tanstack/react-router';
import { Register } from '../components/Register';
import { Pane } from '@sheridan-prize/ui';
import { getAuthStore } from '../main';
import { AccountHeader } from '../components/AccountHeader';

export const Route = createFileRoute('/register')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
  },
  component: Registration,
});

function Registration() {
  return (
    <>
      <AccountHeader />
      <div className="app">
        <Pane classes={'sp-register'} tag="main">
          <Register />
        </Pane>
      </div>
    </>
  );
}
